module.exports = __webpack_public_path__ + "public/media/creator-header.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-header.png
// module id = ./images/services/creator-header.png
// module chunks = 0